"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FootballPeriodName;
(function (FootballPeriodName) {
    FootballPeriodName["pregame"] = "Pre Game";
    FootballPeriodName["regularFirstHalf"] = "First Half";
    FootballPeriodName["regularHalfTime"] = "Half Time";
    FootballPeriodName["regularSecondHalf"] = "Second Half";
    FootballPeriodName["regularTimeFinished"] = "End of Regular Time";
    FootballPeriodName["overtimeFirstHalf"] = "Extra Time - First Half";
    FootballPeriodName["overtimeHalfTime"] = "Extra Time - Break";
    FootballPeriodName["overtimeSecondHalf"] = "Extra Time - Second Half";
    FootballPeriodName["overtimeFinished"] = "Extra Time Finished";
    FootballPeriodName["matchFinishedReg"] = "Full Time";
    FootballPeriodName["matchFinishedOt"] = "Full Time - Extra Time";
    FootballPeriodName["matchFinishedPenReg"] = "Full Time - Penalties";
    FootballPeriodName["matchFinishedPenOt"] = "Full Time - Penalties";
    FootballPeriodName["penaltyShootoutAfterReg"] = "Penalty Shootout";
    FootballPeriodName["penaltyShootoutAfterOt"] = "Penalty Shootout";
    FootballPeriodName["matchCancelled"] = "Match Cancelled";
})(FootballPeriodName = exports.FootballPeriodName || (exports.FootballPeriodName = {}));
var FootballPeriodShortName;
(function (FootballPeriodShortName) {
    FootballPeriodShortName["pregame"] = "Pre Game";
    FootballPeriodShortName["regularFirstHalf"] = "1st Half";
    FootballPeriodShortName["regularHalfTime"] = "Half Time";
    FootballPeriodShortName["regularSecondHalf"] = "Second Half";
    FootballPeriodShortName["regularTimeFinished"] = "Regular Time";
    FootballPeriodShortName["overtimeFirstHalf"] = "ET - 1";
    FootballPeriodShortName["overtimeHalfTime"] = "ET - HT";
    FootballPeriodShortName["overtimeSecondHalf"] = "ET - 2";
    FootballPeriodShortName["overtimeFinished"] = "ET - Fin";
    FootballPeriodShortName["matchFinishedReg"] = "Full Time";
    FootballPeriodShortName["matchFinishedOt"] = "ET - Fin";
    FootballPeriodShortName["matchFinishedPenReg"] = "Fin - Pens";
    FootballPeriodShortName["matchFinishedPenOt"] = "Fin - Pens";
    FootballPeriodShortName["penaltyShootoutAfterReg"] = "Shootout";
    FootballPeriodShortName["penaltyShootoutAfterOt"] = "Shootout";
    FootballPeriodShortName["matchCancelled"] = "Cancelled";
})(FootballPeriodShortName = exports.FootballPeriodShortName || (exports.FootballPeriodShortName = {}));
var FootballPeriodCode;
(function (FootballPeriodCode) {
    FootballPeriodCode["pregame"] = "pregame";
    FootballPeriodCode["regularFirstHalf"] = "firstHalf";
    FootballPeriodCode["regularHalfTime"] = "halfTime";
    FootballPeriodCode["regularSecondHalf"] = "secondHalf";
    FootballPeriodCode["regularTimeFinished"] = "regularTimeFinished";
    FootballPeriodCode["overtimeFirstHalf"] = "overtimeFirstHalf";
    FootballPeriodCode["overtimeHalfTime"] = "overtimeHalfTime";
    FootballPeriodCode["overtimeSecondHalf"] = "overtimeSecondHalf";
    FootballPeriodCode["overtimeFinished"] = "overtimeFinished";
    FootballPeriodCode["matchFinishedReg"] = "matchFinishedReg";
    FootballPeriodCode["matchFinishedOt"] = "matchFinishedOt";
    FootballPeriodCode["matchFinishedPenReg"] = "matchFinishedPenReg";
    FootballPeriodCode["matchFinishedPenOt"] = "matchFinishedPenOt";
    FootballPeriodCode["penaltyShootoutAfterReg"] = "penaltyShootoutAfterReg";
    FootballPeriodCode["penaltyShootoutAfterOt"] = "penaltyShootoutAfterOt";
    FootballPeriodCode["matchCancelled"] = "matchCancelled";
})(FootballPeriodCode = exports.FootballPeriodCode || (exports.FootballPeriodCode = {}));
//# sourceMappingURL=Periods.js.map